;(function() {
  'use strict'

  angular.module('app.survey').component('surveyQuestionChoice', {
    controller: Controller,
    templateUrl: 'survey-question-choice.html',
    bindings: {
      survey: '<',
      question: '<',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.isVisible = isVisible

    function onInit() {
      ctrl.query = ''
      ctrl.visibleChoices = ctrl.question.getVisibleChoices(true)
      ctrl.blocks = ctrl.question.getChoicesAsBlocks(ctrl.visibleChoices)
    }

    function isVisible(choice) {
      if (!ctrl.query) return true
      return choice.option.toLowerCase().includes(ctrl.query.toLowerCase())
    }
  }
})()
